module.exports = __webpack_public_path__ + "images/logicxb36d5166a2b693fb72ddc231e217adc6.png";